module.exports = __webpack_public_path__ + "static/media/cat-lady.0a431288.png";